module.exports = {"nav":{"langChange":"Sprache ändern","lang":"Sprache","translate":"Übersetzen"}};